import * as questionIds from "../../consultationQuestions/questionIds";

export const manualHandlingMSKQuestionnaireQuestions = [
    {
        id: questionIds.MSKManualHandlingAssessmentRequired,
        questionText: "Following Review of the MSK Questionnaire",
    },
    {
        id: questionIds.MSKManualHandlingUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.MSKManualHandlingUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfNeck,
        questionText: "Neck",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfBack,
        questionText: "Back",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftShoulder,
        questionText: "Left Shoulder",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftElbow,
        questionText: "Left Elbow",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfRightShoulder,
        questionText: "Right Shoulder",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfRightElbow,
        questionText: "Right Elbow",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftWrist,
        questionText: "Left Wrist",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftLeg,
        questionText: "Left Leg",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfRightWrist,
        questionText: "Right Wrist",
    },
    {
        id: questionIds.MSKManualHandlingDemonstratedFullMovementOfRightLeg,
        questionText: "Right Leg",
    },
    {
        id: questionIds.MSKManualHandlingDoRestrictionsAffectPerformance,
        questionText: "Do any restrictions affect the performance of your role?",
    },
    {
        id: questionIds.MSKManualHandlingDoRestrictionsAffectPerformanceNotes,
        questionText: "Details/Note",
    },
];
